// =============================================
// NÓ: CONDITION (CONDIÇÃO/DECISÃO) - MOBILE FIRST
// =============================================
// Arquivo: ConditionNode.tsx
// Descrição: Nó de decisão condicional - otimizado para touch
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface ConditionNodeProps {
  data: {
    label?: string;
    condition?: string;
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const ConditionNode: React.FC<ConditionNodeProps> = ({ data, selected }) => {
  return (
    <div className={`custom-node condition-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        id="condition-input"
        className="node-handle target-handle"
      />
      <div className="node-icon">
        <i className="fas fa-code-branch"></i>
      </div>
      <div className="node-content">
        <div className="node-label">{data.label || 'Condição'}</div>
        {data.condition && (
          <div className="node-preview">
            <i className="fas fa-question-circle"></i>
            <span>{data.condition.substring(0, 25)}{data.condition.length > 25 ? '...' : ''}</span>
          </div>
        )}
        <ActionsBadge actions={data.actions} />
      </div>
      <div className="condition-handles">
        <Handle
          type="source"
          position={Position.Bottom}
          id="condition-true"
          className="node-handle source-handle handle-true"
          style={{ left: '30%' }}
        >
          <span className="handle-label">Sim</span>
        </Handle>
        <Handle
          type="source"
          position={Position.Bottom}
          id="condition-false"
          className="node-handle source-handle handle-false"
          style={{ left: '70%' }}
        >
          <span className="handle-label">Não</span>
        </Handle>
      </div>
    </div>
  );
};

export default ConditionNode;
